module.exports = __webpack_public_path__ + "static/media/horizon-animation.9da974fb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horizon-animation.gif
// module id = 383
// module chunks = 0